import {i18n} from './i18n.js'
import * as util from './util.js'

let DCIP = null

function site() {
  if (typeof document == 'undefined') return null

  const e = document.querySelector('title')
  if (!e) return null

  return e.textContent
}

const getParent = (component) => {
  let element = component.root
  while (element = element.parentNode) {
    if (element[DCIP]) {
      return element[DCIP]
    }
  }

  return null
}

class RiotPlugins {
  static setup(riot) {
    DCIP = riot.__.globals['DOM_COMPONENT_INSTANCE_PROPERTY']
  }

  static parent(component) {
    const {onBeforeMount, onBeforeUnmount} = component

    component.onBeforeMount = (props, state) => {
      const parent = getParent(component)
      
      if (parent) {
        parent.tags = parent.tags || {}
        parent.tags[component.name] = parent.tags[component.name] || []
        parent.tags[component.name].push(component)
      }

      onBeforeMount.apply(component, [props, state])
    }

    component.onBeforeUnmount = (props, state) => {
      const parent = getParent(component)

      if (parent) {
        const arr = parent.tags[component.name]
        if (arr) {
          const index = arr.indexOf(component)
          arr.splice(index, 1)
          if (!arr.length) {
            delete parent.tags[component.name]
          }
        }
      }

      onBeforeUnmount.apply(component, [props, state])
    }

    return component
  }

  static i18n(component) {
    const {onBeforeMount} = component

    component.onBeforeMount = (props, state) => {
      component.t = i18n.translate
      component.l = i18n.localize
      component.cap = util.capitalize
      component.tCounter = i18n.translatedCounter
      component.locale = () => i18n.locale

      onBeforeMount.apply(component, [props, state])
    }
  }

  static setTitle(component) {
    const {onBeforeMount, onBeforeUpdate, onBeforeUnmount} = component
    let current = site()

    component.onBeforeMount = (props, state) => {
      const e = document.querySelector('title')

      if (typeof component.title == 'function') {
        if (component.title()) {
          const replace = component.props.replaceTitle
          if (replace) e.textContent = component.title()
          else e.textContent = `${current} - ${component.title()}`
        }
      }

      onBeforeMount.apply(component, [props, state])
    }

    component.onBeforeUpdate = (props, state) => {
      const e = document.querySelector('title')

      if (typeof component.title == 'function') {
        if (component.title()) {
          const replace = component.props.replaceTitle
          if (replace) e.textContent = component.title()
          else e.textContent = `${current} - ${component.title()}`
        }
      }

      onBeforeUpdate.apply(component, [props, state])
    }

    component.onBeforeUnmount = (props, state) => {
      const e = document.querySelector('title')

      if (typeof component.title == 'function') {
        const replace = component.props.replaceTitle
        if (current) {
          e.textContent = current
        }
      }

      onBeforeUnmount.apply(component, [props, state])
    }
  }

}

export default RiotPlugins
